export default "__VITE_ASSET__CrW9cNDk__"